import moment from 'moment'

export const formatDate = (date: any) => {
  if (!date) return null
  const formattedDate = moment(date).format('YYYY-MM-DD')
  return formattedDate === 'Invalid date' ? null : formattedDate
}

export const formatDateType2 = (date: any) => {
  if (!date) return null
  const formattedDate = moment(date, 'DD/MM/YYYY').format('YYYY-MM-DD')

  return formattedDate === 'Invalid date' ? null : formattedDate
}

export const formatDateType3 = (date: any) => {
  if (!date) return null
  const formattedDate = moment(date, 'MM/DD/YYYY').format('YYYY-MM-DD')
  return formattedDate === 'Invalid date' ? null : formattedDate
}

export const formatDateType4 = (date: any) => {
  if (!date) return null
  const formattedDate = moment(date, 'DD/MM/YYYY HH:mm').format('YYYY-MM-DD')
  return formattedDate === 'Invalid date' ? null : formattedDate
}

export const formatDateDDMMYYYY = (date: any) => {
  if (!date) return null
  const formattedDate = moment(date).local().format('DD/MM/YYYY')
  return formattedDate === 'Invalid date' ? null : formattedDate
}

export const formatDateMonth = (date: any) => {
  if (!date) return null
  const formattedDate = moment(date).format('YYYY-MM')
  return formattedDate === 'Invalid date' ? null : formattedDate
}

export const formatDateTimeDDMMYYYY = (date: any) => {
  if (!date) return null
  const formattedDate = moment(date).local().format('DD/MM/YYYY HH:mm')
  return formattedDate === 'Invalid date' ? null : formattedDate
}

export const formatDateUTC = (date: any) => {
  if (!date) return null
  const fechaLocal = new Date(date) // Fecha en la zona horaria local
  const fechaUTC = new Date(
    fechaLocal.getUTCFullYear(),
    fechaLocal.getUTCMonth(),
    fechaLocal.getUTCDate(),
  )
  return fechaUTC.toISOString()
}

export const formatParseDate = (dateStr) => {
  if (!dateStr) return null
  const parts = dateStr.split('/')
  if (parts.length !== 3) return null

  const [day, month, year] = parts
  return new Date(`${year}-${month}-${day}`)
}
